<template>
  <div class="ContactView" v-if="contact && contact.uuid">
    <h1 class="title">
      {{ contact.first_name }} {{ contact.last_name }}
      <span v-if="contact.fonction">({{ contact.fonction.name }})</span>
      <span v-if="contact.partner">@ {{ contact.partner.name }}</span> &nbsp;
      <router-link
        style="font-size: 12px; position: relative; bottom: 4px;"
        :to="`/contact/edit/${contact.uuid}`"
        ><i class="fa fa-edit"></i> éditer</router-link
      >
    </h1>
    <hr />
    <h3 class="subtitle">Coordonnées :</h3>
    <ul>
      <li>Email : {{ contact.email }}</li>
      <li>Téléphone : {{ contact.telephone }}</li>
      <li>
        Diplôme : <span v-if="contact.diploma">{{ contact.diploma.name }}</span>
      </li>
    </ul>
    <hr />
    <h3 class="subtitle">Projets :</h3>
    <div class="tags">
      <div class="tag" v-for="c in contact.projects" :key="c.uuid">
        <router-link :to="`/projects/view/${c.uuid}`">{{ c.name }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { types as t, additions as a } from "../../store/actions/contacts";

export default {
  name: "ContactView",
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      contact: {},
      loading: false
    };
  },
  async mounted() {
    this.contact = await this.$store.dispatch(t.GET_CONTACT_BY_UUID_D, {
      uuid: this.uuid,
      appends: [a.PROJECTS]
    });
  }
};
</script>

<style lang="scss">
.ContactEdit {
}

.ContactContacts {
  padding: 16px;
  border-radius: 3px;
  margin: 1em 0;
}
</style>
